import React from 'react';
import {ToastContainer, ToastStore} from 'react-toasts';

import ProfileSubSectionStyles from './components/ProfileSubSection.css';

import utilities from './components/Utilities';
let Utilities = new utilities();

export default class ChangePassword extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            email: "",
            tel: "",
            firstName: "",
            lastName: "",
            isAdmin: false,
            disabled: true,
            id: ""
        }

    }

    getUser = () => {

        let id = window.location.href;
        let user;
        id = id.substr(id.lastIndexOf('/') + 1);

        if (id === "edit") {
            let user =  JSON.parse(localStorage.getItem("user"));
            let id = user._id;
        } else {
           this.setState({
               isAdmin: true
           })
        }

        this.setState({
            id: id
        })

        window.globalVars.server.api({
            method: "get",
            url: "/api/user/" + id,
            data: {},
            then: function(res) {

                if (Utilities.isENU(res.data.data)) {
                    ToastStore.error("Coudln't get user");
                } else {
                    this.setState({
                        email: res.data.data.email,
                        tel: res.data.data.tel,
                        firstName: res.data.data.firstName,
                        lastName: res.data.data.lastName,
                        disabled: res.data.data.disabled
                    })
                }

            }.bind(this),
            catch: function(e) {

                ToastStore.error("Coudln't get user");

            }.bind(this)
        })

    }

    toggleProfile = () => {

        window.globalVars.server.api({
            method: "post",
            url: "/api/user/update/toggle/" + this.state.id,
            data: {},
            then: function(res) {

                if (res.data.success === false) {
                    ToastStore.error(res.data.data);
                } else {
                    window.location.href = "/admin/customers"
                }

            }.bind(this),
            catch: function(e) {
                ToastStore.error("Couldn't change status");
            }.bind(this)
        })

    }

    updateProfile = () => {

        window.globalVars.server.api({
            method: "post",
            url: "/api/user/update" + ( (this.state.isAdmin) ? "/admin/" + this.state.id : ""),
            data: {
                tel: this.state.tel,
                firstName: this.state.firstName,
                lastName: this.state.lastName
            },
            then: function(res) {

                if (res.data.success === false) {
                    ToastStore.error(res.data.data);
                } else {
                    if (this.state.isAdmin) {
                        window.location.href = "/admin/customers"
                    } else {
                        window.location.href = "/profile"
                    }
                }

            }.bind(this),
            catch: function(e) {
                ToastStore.error("Couldn't change address");
            }.bind(this)
        })

    }

    componentDidMount() {
        this.getUser();
        document.title = window.globalVars.pageTitleBefore + "Profile Edit" + window.globalVars.pageTitleAfter;
        window.scrollTo({top: 0, left: 0, behavior: "smooth"});
    }

    handleChange = (name, value) => {
        let state = this.state;
        state[name] = value;
        this.setState(state);
    }

    render() {

        return (
            <div className="profile-sub-section-container">
                <div className="main-container">
                    <div className="profile-sub-section">
                        <h1>{(this.state.isAdmin) ? "Edit Profile" : "My Account"}</h1>
                        <section>
                            <h2>Update information</h2>
                            <hr />
                            <div>
                                <div className="form-group">
                                    <label for="old-password">Email</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={ (this.state.email || "") }
                                        disabled
                                    />
                                </div>
                                <div className="form-group">
                                    <label for="old-password">First Name</label>
                                    <input
                                        type="text"
                                        id="firstName"
                                        name="firstName"
                                        defaultValue={ (this.state.firstName || "") }
                                        onChange={(e) => { this.handleChange("firstName", e.target.value) } }
                                    />
                                </div>
                                <div className="form-group">
                                    <label for="old-password">Last Name</label>
                                    <input
                                        type="text"
                                        id="lastName"
                                        name="lastName"
                                        defaultValue={ (this.state.lastName || "") }
                                        onChange={(e) => { this.handleChange("lastName", e.target.value) } }
                                    />
                                </div>
                                <div className="form-group">
                                    <label for="old-password">Telephone Number</label>
                                    <input
                                        type="text"
                                        id="tel"
                                        name="tel"
                                        defaultValue={ (this.state.tel || "") }
                                        onChange={(e) => { this.handleChange("tel", e.target.value) } }
                                    />
                                </div>
                                <button onClick={() => {this.updateProfile()}}>
                                    Save
                                </button>
                                { (this.state.isAdmin) &&
                                    <button className="delete-profile-btn" onClick={() => { if (window.confirm("Are you sure you want to " + ( (this.state.disabled === true) ? "enable" : "disable") + " this profile?")) this.toggleProfile() }}>
                                        { (this.state.disabled === true) ? "Enable" : "Disable" }
                                    </button>
                                }
                            </div>
                        </section>
                    </div>
                </div>
                <ToastContainer store={ToastStore}/>
            </div>
        );

    }

}



// WEBPACK FOOTER //
// ./src/ProfileEdit.js